module.exports = __webpack_public_path__ + "img/icons-16-line-add.9e7bd2dc.svg";